export default {
  sidebarWidth: '28%',
  sidebarWidthTablet: '52px',
  drawerWidthDesktop: '320px',
  drawerWidthTablet: '320px',
  drawerHeightPhone: '250px',
  filterFormWidth: '160px',
  eventsDrawerWidth: '320px',
  attentionPanelWidth: '360px',
  bottomBarHeight: 56,
  popupMapOffset: 300,
  popupMaxWidth: 288,
  popupImageHeight: 144,
  headerHeight: 64,
  statsBarHeight: 56,
  navRailWidth: 264,
  navRailWidthCollapsed: 88,
  // The gutter the navigation panel floats inside: it is inset from all four window edges
  // rather than butting against them, so the width it occupies is the panel plus two of these.
  navRailInset: 12,
};
